import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { authenticate } from './api';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Configurations from './pages/Configurations';
import Testing from './pages/Testing';
import Settings from './pages/Settings';
import SavedConfigs from './pages/SavedConfigs';
import AdminServers from './pages/AdminServers';
import Downloads from './pages/Downloads';
import Tests from './pages/Tests';
import Invites from './pages/Invites';
import Leaderboard from './pages/Leaderboard';
import Navigation from './components/Navigation';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function initApp() {
      try {
        // Initialize Telegram WebApp
        if (!window.Telegram || !window.Telegram.WebApp) {
          throw new Error('Not running in Telegram WebApp');
        }

        const tg = window.Telegram.WebApp;

        // Initialize WebApp
        tg.ready();
        tg.expand();

        // Set color scheme
        if (tg.colorScheme) {
          document.documentElement.setAttribute('data-theme', tg.colorScheme);
        }

        // Get init data
        const initData = tg.initData || tg.initDataUnsafe?.toString();

        console.log('Init data available:', !!initData);
        console.log('Init data length:', initData?.length);

        if (!initData) {
          throw new Error('No init data available');
        }

        // Authenticate user
        const { user: userData } = await authenticate(initData);
        setUser(userData);
        setIsAuthenticated(true);

      } catch (err) {
        console.error('Initialization error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    initApp();
  }, []);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Загрузка...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="error">
        <h2>Требуется авторизация</h2>
        <p>Пожалуйста, откройте приложение из Telegram бота.</p>
        {error && (
          <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#fee', borderRadius: '8px' }}>
            <strong>Детали ошибки:</strong>
            <pre style={{ fontSize: '12px', whiteSpace: 'pre-wrap' }}>{error}</pre>
          </div>
        )}
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profile" element={<Profile user={user} />} />
          <Route path="/configurations" element={<Configurations />} />
          <Route path="/testing" element={<Testing />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/saved" element={<SavedConfigs />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/admin/servers" element={<AdminServers />} />
          <Route path="/tests" element={<Tests />} />
          <Route path="/invites" element={<Invites />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
        </Routes>
        <Navigation />
      </div>
    </Router>
  );
}

export default App;
